import React, { useState, useEffect } from 'react';
import { View, Pressable, Switch, ScrollView } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { HMSRoomProvider } from "@100mslive/react-sdk";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import DataState from 'app/src/components/DataState';
import Modal from 'app/src/elements/Modal';
import { useParams } from 'app/src/utils/routing';
import * as colors from 'app/src/styles/colors';
import { Button } from './elements';

import NewStream from './NewStream';
import Buyers from './Buyers';

import {
  ContainerWithFlash,
  Container,
  BorderedContainer,
  ColumnContainer,
  Column,
  Title,
  Subtitle,
  LeftContainer,
  RightContainer,
} from './elements';
import Bids from './Bids';

import SaleAssets from './SaleAssets';
import SaleAssetDetail from './SaleAssetDetail';
import Visit from './Visit';
import { SALE, UPDATE_SALE_BIDDING } from './queries';
import useSubscriptions from './useSubscriptions';
import Header from './Header';
import PriorLot from './PriorLot';
import PreBidAlert from './PreBidAlert';
import moment from 'moment';

const Clerk = () => {
  const { id } = useParams();

  const [showVisitors, setShowVisitors] = useState(false);
  const [showPreBidAlert, setShowPreBidAlert] = useState(false);

  useSubscriptions({ id });

  const { data, refetch } = useQuery(SALE, { variables: { id } });

  useEffect(() => {
    // Handle needing to update to navigating to another page, then back.
    if (data) { refetch(); }
  }, []);

  // useEffect(() => {
  //   if(
  //     data?.sale.biddingSaleAsset?.prebids?.length &&
  //     !data.sale.biddingSaleAsset.bids?.length
  //   ) {
  //     setShowPreBidAlert(true)
  //   }
  // }, [data])

  const [updateSale] = useMutation(UPDATE_SALE_BIDDING, {
    onCompleted: (response) => {
      console.log('response', response)
    }
  });

  const toggleBidding = () => {
    if (data.sale.bidding) {
      if (!confirm('Really make sale inactive?')) {
        return;
      }
    }

    let variables = {
      id,
      bidding: !data.sale.bidding
    }

    if(data.sale.status !== 'Live' && !data.sale.bidding) {
      variables['status'] = 'Live';
    }

    updateSale({variables: variables});
  };

  const closeSale = () => {
    if (data.sale.status === 'Live' && confirm('Really end sale?')) {
      updateSale({
        variables: { id, status: 'Processing', endAt: moment()._d }
      });
    }
  }

  if (!data) { return <DataState.Loading />; }

  return (
    <ContainerWithFlash>
      <Container style={{minHeight: '93vh', maxHeight: '93vh'}}>
        <Header sale={data.sale} />
        <ColumnContainer style={{width: '100%'}}>

          <Column style={{width: '50%'}}>
            <View style={{minHeight: '93vh', borderBottomWidth: '3px'}}>

              <BorderedContainer
                style={{diplay: 'flex', flexDirection: 'row',
                  borderRightWidth: '0px',
                }}
              >
                <LeftContainer>
                  <HMSRoomProvider>
                    <Visit saleId={id} page="Clerk" />
                    {data.sale.bidding && (
                      <>
                        <NewStream
                          userName="Clerk"
                          roomCode={data.sale.viewerRoomCode}
                          activeStream={data.sale.activeStream}
                          sale={data.sale}
                        />
                      </>
                    )}
                  </HMSRoomProvider>
                </LeftContainer>
                <RightContainer >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                      padding: '5px'
                    }}
                  >
                    <Subtitle>Sale Active?</Subtitle>
                    <Switch
                      value={data.sale.bidding}
                      onValueChange={toggleBidding}
                      activeTrackColor={colors.elGreen}
                      activeThumbColor={colors.elGray}
                      style={{marginHorizontal: 10, marginTop: '5px'}}
                    />
                    {!data.sale.bidding ?
                      <Button
                        color={colors.elRed}
                        title={data.sale.status === 'Live' ?
                          "End the Sale" : "Sale Processing"
                        }
                        style={{
                          paddingLeft: '10px',
                          paddingRight: '10px',
                          paddingTop: '5px',
                          paddingBottom: '5px',
                          maxWidth: 'fit-content'
                        }}
                        onPress={() => closeSale()}
                      /> :
                      null
                    }
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                      marginTop: '10px'
                    }}
                  >
                    {data.sale.lotsRemainingLabel}
                    {' | '}
                    {data.sale.activeBidderCount} Bidders Online{' '}
                    <Pressable
                      onPress={() => setShowVisitors(true)}
                      style={{marginLeft: '10px'}}
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} size="sm" />
                    </Pressable>
                  </div>
                </RightContainer>
              </BorderedContainer>
              <BorderedContainer
                style={{
                  border: 'none', padding: '0px'
                }}
              >
                <Bids
                  saleAsset={data.sale.bidding && data.sale.biddingSaleAsset}
                  canInput
                  sale={data.sale}
                  biddingNotice={data?.sale?.biddingNotice}
                  updateSale={updateSale}
                />
              </BorderedContainer>
            </View>
          </Column>
          <Column
            style={{
              width: '25%', left: '50%'
            }}
          >
            <View style={{height: '93vh'}}>
              {data.sale.biddingSaleAsset ? (
                <SaleAssetDetail
                  saleAsset={data.sale.biddingSaleAsset}
                  groupSaleAssets={data.sale.bidGroupSaleAssets}
                  clerk
                />
              ) : (
                <BorderedContainer>
                  <Title>No Assets Current Bidding</Title>
                </BorderedContainer>
              )}
              <PriorLot priorSaleAsset={data.sale.priorSaleAsset} />
            </View>
          </Column>
          <Column
            style={{width: '25%', left: '75%', border: 'none'}}
          >
            <ScrollView style={{minHeight: '93vh'}}>
              <SaleAssets sale={data.sale} updateSale={updateSale} />
            </ScrollView>
          </Column>
        </ColumnContainer>
      </Container>
      {/* <>
        <Column style={{ flex: 6 }}>
          <BorderedContainer style={{overflow: 'auto'}}>

            <Field>
              <Label>Update:</Label>
              <StyledTextInput
                onChange={e => setBiddingNotice(e.target.value)}
                value={biddingNotice || ''}
                onKeyPress={handleKeyPress}
              />
              <Button
                color={colors.elGreen}
                title="Show"
                onPress={() => saveBiddingNotice()}
              />
              <Button
                color={colors.elRed}
                title="Save"
                onPress={() => (
                  createBiddingNotice({ variables: { message: biddingNotice } })
                )}
              />
            </Field>
            <Split />

            <Bids
              saleAsset={data.sale.bidding && data.sale.biddingSaleAsset}
              canInput
              sale={data.sale}
            />
          </BorderedContainer>
        </Column>
        <Column style={{ flex: 5 }}>
          <SaleAssets sale={data.sale} updateSale={updateSale} />
        </Column>
        <Column style={{ flex: 4 }}>
          {data.sale.biddingSaleAsset ? (
            <SaleAssetDetail
              saleAsset={data.sale.biddingSaleAsset}
              groupSaleAssets={data.sale.bidGroupSaleAssets}
              clerk
            />
          ) : (
            <BorderedContainer>
              <Title>No Assets Current Bidding</Title>
            </BorderedContainer>
          )}
        </Column>
      </> */}
      {showVisitors && (
        <Modal
          showModal={showVisitors}
          setShowModal={setShowVisitors}
          modalType="Online Users"
        >
          <Buyers sale={data.sale} />
        </Modal>
      )}
      {showPreBidAlert && (
        <Modal
          showModal={showPreBidAlert}
          setShowModal={setShowPreBidAlert}
          modalType="Existing Pre-Bids"
        >
          <PreBidAlert sale={data.sale} />
        </Modal>
      )}
    </ContainerWithFlash>
  );
};

export default Clerk;
